import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Stack } from '@mui/material';

import AppButton from '@/shared/ui/AppButton';

import { getSearchCategoryLabelKey } from '../model/categories';
import { SearchCategory } from '../model/types';

export type SearchTabKey = 'ALL' | SearchCategory;

export interface SearchTabOption {
  key: SearchTabKey;
  count: number;
}

interface Props {
  tabs: SearchTabOption[];
  activeTab: SearchTabKey;
  onChange: (tab: SearchTabKey) => void;
}

const SearchResultTabs: FC<Props> = ({ tabs, activeTab, onChange }) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      gap="0.375rem"
      sx={{
        padding: '0 0.75rem 0.625rem',
        overflowX: 'auto',
        borderBottom: '1px solid',
        borderColor: 'grey.100',
        flexShrink: 0,
      }}
      role="tablist"
    >
      {tabs
        .filter(({ key, count }) => key === 'ALL' || count > 0)
        .map(({ key, count }) => {
          const isActive = key === activeTab;

          return (
            <AppButton
              key={key}
              variant={isActive ? 'p-rounded' : 's-rounded'}
              size="small"
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(key)}
              data-testid={`search-tab-${key.toLowerCase()}`}
              sx={{ flexShrink: 0, gap: '0.375rem' }}
            >
              {key === 'ALL' ? t('search.tabs.all') : t(getSearchCategoryLabelKey(key))}
              <Box component="span" sx={{ opacity: 0.65, fontVariantNumeric: 'tabular-nums' }}>
                {count}
              </Box>
            </AppButton>
          );
        })}
    </Stack>
  );
};

export default SearchResultTabs;
